<template>
  <div id="div-tabela-kpis-by-municipio">
    <div
      v-if="loading"
      class="d-flex align-center justify-center"
      style="min-height: 420px;"
    >
      <v-progress-circular indeterminate color="primary" size="32" />
    </div>
    <template v-else>
      <v-text-field
        v-if="numMunicipios > 10"
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto mb-5 break-search"
        label="Procurar"
        hide-details
        single-line
      />
      <v-data-table
        class="data-table-kpis"
        dense
        :headers="headers"
        :items="items"
        :search="search"
        :items-per-page="10"
        no-data-text="Nenhum registro disponível"
        no-results-text="Nenhum registro correspondente encontrado"
      >
        <template
          v-for="h in headers"
          v-slot:[`header.${h.value}`]="{ header }"
        >
          <v-tooltip bottom v-if="traducaoIndicadores[h.value] != null">
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ h.text }}</span>
            </template>
            <span>{{ traducaoIndicadores[h.value] }}</span>
          </v-tooltip>
          <span v-else>{{ h.text }}</span>
        </template>

        <template v-slot:[`item.qlp`]="{ item }">
          {{ item.qlp | parseNumberToFloatBrIgnoringNaN }}
        </template>
        <template v-slot:[`item.pla`]="{ item }">
          {{ item.pla | parseNumberToFloatBrIgnoringNaN }}%
        </template>
        <template v-slot:[`item.pmea15`]="{ item }">
          {{ item.pmea15 | parseNumberToFloatBrIgnoringNaN }}
        </template>
        <template v-slot:[`item.pmea30`]="{ item }">
          {{ item.pmea30 | parseNumberToFloatBrIgnoringNaN }}
        </template>
        <template v-slot:[`item.pmea45`]="{ item }">
          {{ item.pmea45 | parseNumberToFloatBrIgnoringNaN }}
        </template>
        <template v-slot:[`item.pat1`]="{ item }">
          {{ item.pat1 | parseNumberToFloatBrIgnoringNaN }}
        </template>
        <template v-slot:[`item.pat2`]="{ item }">
          {{ item.pat2 | parseNumberToFloatBrIgnoringNaN }}
        </template>
        <template v-slot:[`item.pat3`]="{ item }">
          {{ item.pat3 | parseNumberToFloatBrIgnoringNaN }}
        </template>
        <template v-slot:[`item.pat4`]="{ item }">
          {{ item.pat4 | parseNumberToFloatBrIgnoringNaN }}
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
export default {
  name: "KpisByMunicipioDataTable",
  props: {
    dadosKpisByMunicipio: {
      type: Array,
      required: true,
    },
    traducaoIndicadores: {
      type: Object,
      default: {},
    },
    loading: { type: Boolean, default: false },
  },
  data: () => ({
    headers: [
      {
        text: "IBGE",
        value: "codigo_ibge",
      },
      {
        text: "Município",
        value: "nome_municipio",
        width: "100px",
      },
      {
        value: "qlp",
        text: "QLP",
      },
      {
        value: "pla",
        text: "PLA",
      },
      {
        value: "pmea15",
        text: "PMEA15",
      },
      {
        value: "pmea30",
        text: "PMEA30",
      },
      {
        value: "pmea45",
        text: "PMEA45",
      },
      {
        value: "pat1",
        text: "PAT1",
      },
      {
        value: "pat2",
        text: "PAT2",
      },
      {
        value: "pat3",
        text: "PAT3",
      },
      {
        value: "pat4",
        text: "PAT4",
      },
    ],
    search: "",
  }),
  computed: {
    numMunicipios() {
      return this.dadosKpisByMunicipio ? this.dadosKpisByMunicipio.length : 0;
    },
    items() {
      return this.dadosKpisByMunicipio;
    },
  },
  methods: {},
};
</script>

<style>
#div-tabela-kpis-by-municipio {
  min-height: 420px;
}
.data-table-kpis table tbody tr td {
  font-size: 12px;
  padding: 0px 8px !important;
}
.data-table-kpis table thead tr th {
  font-size: 12px;
  height: 25px;
  font-weight: 400;
}
</style>
